import ApiServer from '@/utils/api/ApiServer.js'
import { Pagination } from '@/utils/constants.js'

export default {
  async fetchPendingApprovals (_, { page = 1, pageSize = Pagination.DefaultPageSize } = {}) {
    const path = ApiServer.urlFor(['duediligence'], {
      params: { page, pageSize, includePendingReview: true }
    })
    const response = await ApiServer.get(path)
    return response.data
  },

  async fetchApprovalQueue (context) {
    const pageSize = Pagination.MaxPageSize
    const first = await context.dispatch('fetchPendingApprovals', { page: 1, pageSize })
    const all = [...(first?.items ?? [])]
    for (let page = 2; page <= (first?.totalPages ?? 1); page++) {
      const next = await context.dispatch('fetchPendingApprovals', { page, pageSize })
      all.push(...(next?.items ?? []))
    }
    return all.sort((a, b) => new Date(a.requestedAt) - new Date(b.requestedAt))
  },

  async fetchDecidedApprovals (_, { page = 1, pageSize = Pagination.DefaultPageSize, teamIds, mitigationGroupIds, riskPresence, includeApproved, includeReturned, resolvedFrom, resolvedTo } = {}) {
    const path = ApiServer.urlFor(['duediligence'], {
      params: { page, pageSize, teamIds, mitigationGroupIds, riskPresence, includeApproved, includeReturned, resolvedFrom, resolvedTo }
    })
    const response = await ApiServer.get(path)
    return response.data
  },

  async decideDueDiligence (_, { tractId, decision, comment }) {
    const path = `tracts/${tractId}/duediligence`
    const response = await ApiServer.put(path, { decision, comment: comment || null })
    return response.data
  }
}
